/* ==============================================================================================
 * TABLE BUILDER
 *
 * Helper to create table markup.
 * ============================================================================================== */

var Sushi, CGS, Icons, $ = window.jQuery;

(function (Sushi, CGS, Icons) {
	"use strict";


	/* General markup
	 * ------------------------------------------------------------------------------------------ */

	CGS.createTableCell = function (data, type) {
		type = type || "td";

		var cell = document.createElement(type);

		cell.classList.add("c-table__cell");

		if (data.sort) {
			cell.classList.add("c-table__cell--sortable");
		}

		if (data.search) {
			cell.classList.add("c-table__cell--searchable");
		}

		cell.innerHTML = data.content;

		return cell;
	};

	CGS.createCheckboxCell = function (content) {
		var checkboxCell = document.createElement("th");

		checkboxCell.classList.add("c-table__cell");
		checkboxCell.classList.add("c-table__cell--checkbox");

		if (content) {
			checkboxCell.appendChild(content);
		}

		return checkboxCell;
	};

	CGS.createChekboxInput = function (data, modifier) {
		var cellContent = document.createElement("div");
		var checkbox = document.createElement("input");
		var label = document.createElement("label");

		checkbox.setAttribute("type", "checkbox");
		checkbox.setAttribute("id", "th_" + data.id);
		checkbox.classList.add("c-table__select", "c-table__select--" + modifier);
		label.setAttribute("for", "th_" + data.id);
		label.classList.add("c-table__selectLabel");

		if (!data.files) {
			checkbox.classList.add("c-input__box");
		}

		cellContent.appendChild(checkbox);
		cellContent.appendChild(label);

		return cellContent;
	};

	CGS.createTableRow = function () {
		var row = document.createElement("tr");

		row.classList.add("c-table__row");

		return row;
	};

	CGS.createTableBody = function () {
		var tbody = document.createElement("tbody");

		tbody.classList.add("c-table__body");

		return tbody;
	};

	CGS.createTableHead = function () {
		var thead = document.createElement("thead");

		thead.classList.add("c-table__head");

		return thead;
	};

	CGS.createTableHtml = function (data) {
		if (!data) {
			return;
		}

		var table = document.createElement("table");
		var tableContainer = document.createElement("div");
		var tableSlider = document.createElement("div");
		var tableLoader = document.createElement("div");

		table.classList.add("c-table");
		table.style.width = "100%";
		tableContainer.classList.add("c-table__container");
		tableSlider.classList.add("c-table__slider");
		tableLoader.classList.add("c-tableLoader");

		if (data.checkbox) {
			table.classList.add("c-table--selectable");
		}

		if (data.files) {
			table.classList.add("c-table--files");
		}

		if (data.showSelectAll) {
			table.classList.add("c-table--showSelectAll");
		}

		if (data.details) {
			table.classList.add("c-table--withDetails");
		}

		var headElement = CGS.createTableHead();
		var bodyElement = CGS.createTableBody();

		if (data.head) {
			Sushi.Dom.forEach(data.head.rows, function (row) {
				var rowElement = CGS.createTableRow();

				if (data.checkboxes) {
					var checkboxCell = CGS.createCheckboxCell();

					if (data.showSelectAll) {
						checkboxCell.appendChild(CGS.createChekboxInput(row, "all"));
					}

					rowElement.appendChild(checkboxCell);
				}

				Sushi.Dom.forEach(row.cells, function (cell) {
					rowElement.appendChild(CGS.createTableCell(cell, "th"));
				});

				headElement.appendChild(rowElement);
			});

			table.appendChild(headElement);
		}

		if (data.body) {
			Sushi.Dom.forEach(data.body.rows, function (row) {
				var rowElement = CGS.createTableRow();

				if (data.checkboxes) {
					var checkboxCell = CGS.createCheckboxCell();
					var checkbox = CGS.createChekboxInput(row, "single");

					checkboxCell.appendChild(checkbox);
					rowElement.appendChild(checkboxCell);
				}

				Sushi.Dom.forEach(row.cells, function (cell) {
					rowElement.appendChild(CGS.createTableCell(cell));
				});

				bodyElement.appendChild(rowElement);
			});

			table.appendChild(bodyElement);
		}

		tableContainer.appendChild(table);
		tableContainer.appendChild(tableLoader);
		tableSlider.appendChild(tableContainer);

		return tableSlider;
	};


	/* Specific markup
	 * ------------------------------------------------------------------------------------------ */

	/**
	 * A table without expand button
	 *
	 * @param {object} settings
	 */
	CGS.createRetractTableWrapper = function (settings) {
		var bodyWrapper = document.createElement("div");

		settings.nScrollBody.parentNode.appendChild(bodyWrapper);
		settings.nTableWrapper.classList.add("c-table--retract");
		bodyWrapper.classList.add("c-table__bodyWrapper");
		bodyWrapper.appendChild(settings.nScrollBody);
	};


	/* Cell renderers
	 * ------------------------------------------------------------------------------------------ */

	/**
	 * @param data The cell data
	 * @param {number} width The cell min-width
	 */
	CGS.setCellMinWidth = function (data, width) {
		return "<div style='min-width:" + width + "px'>" + data + "</div>";
	};

	CGS.renderRemoveCell = function () {
		var cell = document.createElement("a");

		cell.setAttribute("href", "#");
		cell.setAttribute("title", "Remove from Export List");
		cell.innerHTML = Icons.remove();

		return cell.outerHTML;
	};

	CGS.renderIssueDescriptionCell = function (data, linkToIssueDetails) {
		var description = data.issueDescription;

		if (linkToIssueDetails) {
			description = "<a data-plugin='IssueDetail' "
				+ "href='#' "
				+ "data-content='#newIssueDetailModal' "
				+ "data-issuer-number='" + data.issuerNumber + "' "
				+ "data-issue-number='" + data.issueNumber + "' "
				+ "data-issue-check='" + data.issueCheck + "' "
				+ "data-issuer-last-updated='" + data.issuerLastUpdated + "'>"
				+ data.issueDescription + " " + data.issueDescription
				+ "</a>";
		}

		if (data.issuerTypeCode !== "M") {
			return description;
		}

		var tooltipContent = "";

		tooltipContent += "<div class='_dn'>";
		tooltipContent += "<div class='_fz12' id='issueTooltipTemplate"
			+ data.issuerNumber
			+ "'>";
		tooltipContent += "<p>"
			+ "To review official documentation click on MSRB link below"
			+ "</p>";
		tooltipContent += "<a class='_red _hover:tdu' "
			+ "href='#'>"
			+ "Municipal Securities Rulemaking Board's EMMA® website"
			+ "</a>";
		tooltipContent += "</div>";
		tooltipContent += "</div>";

		var iconHtml = "";

		iconHtml += "<span class='_gray20 _c' "
			+ "data-tooltip='issueTooltip' "
			+ "data-tooltip-trigger-event='click' "
			+ "data-tooltip-content='#issueTooltipTemplate"
			+ data.issuerNumber
			+ "'>";
		iconHtml += Icons.tooltip();
		iconHtml += "</span>";

		var html = "";

		html += "<p class='_df _aic'>";
		html += "<span class='_mrxxs'>";
		html += description;
		html += "</span>";
		html += iconHtml;
		html += "</p>";
		html += tooltipContent;

		return html;
	};

	CGS.renderFileExportCheckCell = function (identifier, uid) {
		if (!uid) {
			uid = identifier;
		}

		var inputEl = document.createElement("input");
		var labelEl = document.createElement("label");

		inputEl.type = "checkbox";
		inputEl.classList.add("c-table__select");
		inputEl.id = "th_" + uid;

		labelEl.htmlFor = "th_" + uid;
		labelEl.classList.add("c-table__selectLabel");
		labelEl.title = "Add to Export List";
		labelEl.setAttribute("data-tooltip", "dt-file-check");

		return CGS.setCellMinWidth((inputEl.outerHTML + labelEl.outerHTML), 30);
	};


	/* Columns definition getters
	 * ------------------------------------------------------------------------------------------ */

	CGS.getNewIssuesTableColumns = function () {
		return [
			{
				data: null,
				orderable: false,
				className: "c-table__cell c-table__cell--checkbox",
			},
			{
				data: null,
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "issueDatedDate",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "issueMaturityDate",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: "issueCoupon",
				className: "c-table__cell",
				searchable: true,
			},
			{
				data: null,
				className: "c-table__cell",
				searchable: true,
			},
		];
	};

	CGS.getNewIssuesTableColumnDefs = function () {
		return [
			{
				targets: [0],
				render: function (data, type, row) {
					return CGS.renderFileExportCheckCell(
						row.issueDescription,
						row.issuerNumber + row.issueNumber + row.issueCheck
					);
				},
			},
			{
				targets: [1],
				render: function (data) {
					return CGS.renderIssueDescriptionCell(data, true);
				},
			},
			{
				targets: [2],
				render: function (data, type, row) {
					if (data !== "") {
						return data;
					}
					else if (row.issuePartialMaturity !== "") {
						return "00/00/" + row.issuePartialMaturity;
					}
					else {
						return "";
					}
				},
			},
			{
				targets: [5],
				render: function (data) {
					return data.issuerNumber + data.issueNumber + data.issueCheck;
				},
			},
		];
	};


	/* Custom buttons
	 * ------------------------------------------------------------------------------------------ */

	CGS.getClearExportListButton = function () {
		return {
			text: "Clear Export List",
			className: "c-tableExport__clear o-bareBtn",
			action: function (e, dt, node, config) {
				// TODO: Implement "Clear export list"
				window.location.href = "#";
				console.log("Clear export list");
			},
		};
	};

	CGS.getExportToExcelButton = function () {
		var btnContainer = document.createElement("span");
		var icoContainer = document.createElement("span");

		btnContainer.setAttribute("class", "_df _aic _jcsb");
		btnContainer.innerText = "Export data to Excel";

		icoContainer.setAttribute("class", "_mlxxs");
		icoContainer.innerHTML += Icons.arrowRight();

		btnContainer.appendChild(icoContainer);

		return {
			text: btnContainer.outerHTML,
			className: "c-tableExport__export o-bareBtn",
			extend: "excel",
		};
	};


	/* Miscellaneous
	 * ------------------------------------------------------------------------------------------ */

	/**
	 * @param {object} sourceSettings
	 * @param {object} sourceData
	 * @param {{
	 * 		ajax: (string | {
	 * 		 	url: string,
	 * 			dataSrc: (string|undefined),
	 * 		}),
	 *  	columns: object[],
	 *  	columnDefs: object[],
	 *  	tableFn: function
	 * }} childTableOptions
	 */
	CGS.setupChildTables = function (sourceSettings, sourceData, childTableOptions) {
		$(sourceSettings.nTBody.rows).on("click", function (event) {
			if (event.target.tagName === "A") {
				return;
			}

			var tr = $(this);
			var row = $(sourceSettings.nTable).DataTable().row(tr);

			if (row.child.isShown()) {
				$("div.c-table__slider", row.child()).slideUp("fast", function () {
					row.child.hide();
					tr.removeClass("is-open shown");
				});
			}
			else {
				var childTableEl = childTableOptions.tableFn();

				row.child(childTableEl, "_p0").show();
				row.child().addClass("c-table__detailRow");
				$("div.c-table__slider", row.child()).slideDown("fast");
				tr.addClass("is-open shown");

				var newTable = CGS.table(childTableEl.querySelector("table"), {
					ajax: childTableOptions.ajax,
					columns: childTableOptions.columns,
					columnDefs: childTableOptions.columnDefs,
					paging: false,
					dom: "<'top'>rt<'c-tableFooter'<'_1/3@laptop'>i<'c-table__export'B>>",
					initComplete: function () {
						newTable.columns.adjust();

						setTimeout(function () {
							$("[data-tooltip=issueTooltip]").tooltipster({
								interactive: true,
								contentCloning: true,
								theme: "tooltipster--light",
								trigger: Sushi.Util.isMobile() ? "click" : "hover",
								maxWidth: 420,
							});
						});
					},
				});
			}
		});
	};

})(Sushi || (Sushi = {}), CGS || (CGS = {}), Icons || (Icons = {}));
